import React, { useEffect, useState } from 'react';
export function ScrollProgressBar() {
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scroll = `${totalScroll / windowHeight * 100}`;
      setScrollProgress(Number(scroll));
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed top-0 left-0 w-full h-1 z-[10000] bg-navy-dark" data-id="element-247">
      <div className="h-full bg-gold transition-all duration-150 ease-out" style={{
      width: `${scrollProgress}%`
    }} data-id="element-248" />
    </div>;
}